import { ChangeEvent } from 'react';

type OnChangeFn = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;

export function onQlfRteChange(
  onChange: OnChangeFn,
  getCurrentValue: () => string,
): (value: any) => void {
  return ({ target: { value } }) => {
    const newValue = value === '<p><br></p>' ? '' : value;
    const currentValue = getCurrentValue();
    if (newValue !== currentValue && newValue !== `<p>${currentValue}</p>`) {
      onChange(newValue);
    }
  };
}
